/**
 * Main App component with routing
 */

import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import MainLayout from './layouts/MainLayout';
import Login from './pages/Login';
import Home from './pages/Home';
import PublicDirectory from './pages/PublicDirectory';
import CreateQuiz from './pages/CreateQuiz';
import EditQuiz from './pages/EditQuiz';
import TakeQuiz from './pages/TakeQuiz';
import QuizHistory from './pages/QuizHistory';
import GroupQuizHost from './pages/GroupQuizHost';
import GroupQuizJoin from './pages/GroupQuizJoin';
import VerifyEmail from './pages/VerifyEmail';
import UserProfile from './pages/UserProfile';
import './styles/global.css';

export function App() {
    return (
        <AuthProvider>
            <BrowserRouter>
                <Routes>
                    <Route path="/login" element={<Login />} />

                    <Route
                        path="/"
                        element={
                            <ProtectedRoute>
                                <MainLayout>
                                    <Home />
                                </MainLayout>
                            </ProtectedRoute>
                        }
                    />

                    <Route
                        path="/public-directory"
                        element={
                            <ProtectedRoute>
                                <MainLayout>
                                    <PublicDirectory />
                                </MainLayout>
                            </ProtectedRoute>
                        }
                    />

                    <Route
                        path="/quiz/create"
                        element={
                            <ProtectedRoute>
                                <MainLayout>
                                    <CreateQuiz />
                                </MainLayout>
                            </ProtectedRoute>
                        }
                    />

                    <Route
                        path="/quiz/:id/edit"
                        element={
                            <ProtectedRoute>
                                <MainLayout>
                                    <EditQuiz />
                                </MainLayout>
                            </ProtectedRoute>
                        }
                    />

                    <Route
                        path="/quiz/:id/take"
                        element={
                            <ProtectedRoute>
                                <MainLayout>
                                    <TakeQuiz />
                                </MainLayout>
                            </ProtectedRoute>
                        }
                    />

                    <Route
                        path="/quiz/:id/history"
                        element={
                            <ProtectedRoute>
                                <MainLayout>
                                    <QuizHistory />
                                </MainLayout>
                            </ProtectedRoute>
                        }
                    />

                    {/* Group Quiz Routes */}
                    <Route
                        path="/group-quiz/:hash/host"
                        element={
                            <ProtectedRoute>
                                <MainLayout>
                                    <GroupQuizHost />
                                </MainLayout>
                            </ProtectedRoute>
                        }
                    />

                    {/* Public join route - no authentication required */}
                    <Route
                        path="/group-quiz/:hash/join"
                        element={<GroupQuizJoin />}
                    />

                    {/* Email Verification Route */}
                    <Route
                        path="/user/:userId/verify"
                        element={
                            <ProtectedRoute>
                                <VerifyEmail />
                            </ProtectedRoute>
                        }
                    />

                    {/* User Profile Route */}
                    <Route
                        path="/user/:userId"
                        element={
                            <ProtectedRoute>
                                <MainLayout>
                                    <UserProfile />
                                </MainLayout>
                            </ProtectedRoute>
                        }
                    />

                    <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
            </BrowserRouter>
        </AuthProvider>
    );
}
